<section class="page-container">
  <div class="container-fluid" style="padding: 0">
    <div class="polo-header">
      <h1>Ford
        <br>
        <span>Ranger</span>
      </h1>
      <img src="../../assets/images/showroom-banners/ranger.png">
    </div>
  </div>
</section>
<app-showroom></app-showroom>
